export default __webpack_public_path__ + "static/media/2018.1ff99dd9.png";